import React, { useContext } from 'react';
import styles from './MfSelectComposition.module.css';
import { CheckedIcon, CompositionIcon } from 'features/compositions/assets/icons/icons';
import { useCompositionsContext } from 'features/compositions/context/CompositionsContext';
import { ArrowRightIcon } from 'assets/icons';
import useTheme from 'config/useTheme';
import AuthenticationContext from 'config/context/authenticationContext';
import { useMfImport } from 'features/compositions/context/MfImportContext';

const MfSelectComp = () => {
    const { dark } = useTheme();
    const { getCompositionPermission } = useContext(AuthenticationContext);
    const { compositionNames } = useCompositionsContext();
    const { setStep, selectedComposition, setSelectedComposition, setSelectedPermission } = useMfImport();
    
    const goToAuth = () => {
        setStep(3);
    }

    const selectComp = (t) => {
        setSelectedComposition(t);
        setSelectedPermission(getCompositionPermission(t));
    }

    return (
        <div className={`${styles.select_composition} ${dark ? styles.dark : ''}`}>
            <div className={styles.compositions_list}>
                {compositionNames?.map((t) => (
                    <button key={t} onClick={() => selectComp(t)} className={selectedComposition === t ? styles.active : ''}>
                        <span><CompositionIcon /> {t}</span> <div><CheckedIcon /></div>
                    </button>
                ))}
            </div>
            <button disabled={!selectedComposition} onClick={() => goToAuth()} className={styles.go_to_auth}>Go to authorization <ArrowRightIcon /></button>
        </div>
    )
}

export default MfSelectComp;